import {User,} from '@/shared/models';
import {BookingContext} from '../models';
import {testUser} from '@/shared/data';

export const INIT_BOOKING_CONTEXT = new BookingContext({
    user: new User(testUser)
});
